import { Dayjs } from 'dayjs';
import { getTimeOfDayAvailability } from './entity';
import { Service } from '../service/entity';
import {
  WorkingHoursScheduleType,
  DEFAULT_WEEKLY_SCHEDULE,
  isDateHoliday,
  isWorkingDay,
} from './schedule/entity';
import { WorkingDay } from './schedule/store';

export const useHighlightedDays = (
  getAvailableSlots: (
    workingDay: WorkingDay,
    service: Service | undefined,
    step?: number,
  ) => {
    start: string;
    end: string;
  }[],
) => {
  const getAvailableSlotsForDate = (
    targetDateStr: string,
    targetService: Service,
    workingSchedule: WorkingHoursScheduleType | undefined,
  ) => {
    if (!workingSchedule || !targetService) {
      return [];
    }

    const defaultValuesWorkingSchedule = {
      weeklySchedule: workingSchedule.weeklySchedule || DEFAULT_WEEKLY_SCHEDULE,
      holidays: workingSchedule.holidays || [],
    };

    return getAvailableSlots(
      { workingSchedule: defaultValuesWorkingSchedule, targetDate: targetDateStr },
      targetService,
    );
  };

  const processDayAvailability = (
    targetDate: Dayjs,
    targetService: Service,
    workingSchedule: WorkingHoursScheduleType | undefined,
  ): 'morning' | 'afternoon' | 'both' | null => {
    if (!workingSchedule) {
      return null;
    }

    const defaultValuesWorkingSchedule = {
      weeklySchedule: workingSchedule?.weeklySchedule || DEFAULT_WEEKLY_SCHEDULE,
      holidays: workingSchedule?.holidays || [],
    };

    if (isDateHoliday(targetDate, defaultValuesWorkingSchedule)) {
      return null;
    }

    if (!isWorkingDay(targetDate, defaultValuesWorkingSchedule)) {
      return null;
    }

    const targetDateStr = targetDate.format('YYYY-MM-DD');
    const availableSlots = getAvailableSlotsForDate(targetDateStr, targetService, workingSchedule);

    if (availableSlots.length === 0) {
      return null;
    }

    return getTimeOfDayAvailability(availableSlots);
  };

  return { processDayAvailability };
};
